import { render, staticRenderFns } from "./Fruits.vue?vue&type=template&id=4c8b2232&scoped=true&"
import script from "./Fruits.vue?vue&type=script&lang=js&"
export * from "./Fruits.vue?vue&type=script&lang=js&"
import style0 from "./Fruits.vue?vue&type=style&index=0&id=4c8b2232&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8b2232",
  null
  
)

export default component.exports